import { createSelector } from "reselect";
import { layoutsSelector, pageLayoutIdSelector } from "./state";

export const layoutItemSelector = createSelector([pageLayoutIdSelector, layoutsSelector], (id, items) =>
  id ? items.find((x) => x.id === id) : null
);
export const layoutSettingsSelector = createSelector([layoutItemSelector], (item) => item?.settings);
export const layoutLocalSelector = createSelector([layoutItemSelector], (item) => item?.local);
